
    export default {
        name: 'TeamMemberCard',
        props: {
            teamMember: {
                type: Object,
                required: true,
            },
        },
    };
